import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-pencil',
  imports: [],
  templateUrl: './icon-pencil.component.html',
})
export class IconPencilComponent {
  @Input() color: string = 'currentColor';
  @Input() size: string = '24px';
}
